var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('span',{directives:[{name:"time",rawName:"v-time",value:(_vm.time),expression:"time"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }